<button class="btn" [type]="type" (click)="onClick()" [disabled]="isLoading">
  {{ text || ('Common.Button.confirm' | translate) }}
</button>